import React, { useState } from "react";
import {
  Modal,
  Box,
  Grid,
  TextField,
  MenuItem,
  FormHelperText,
  FormControl,
  FormLabel,
  InputLabel,
  Select,
  IconButton,
} from "@mui/material";
import styles from "../../styles/fabricationModal.module.css";
import axios from "axios";
import { Close, UploadFile } from "@mui/icons-material";
import imageCompression from "browser-image-compression";
import GlobalButton from "../../shared/utils/GlobalButton.jsx";

const PrintMachineModal = ({
  brandNames,
  isOpen,
  handleSubmit,
  handleChange,
  handleDateChange,
  setPmFormData,
  printingSubOptions,
  handleClose,
  formData,
  printingOptions,
  isOtherSelected,
  isEditing,
  width,
  substrate,
  error,
}) => {
  const [uploadLoading, setUploadLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const selectedBrandNames =
    brandNames.find((item) => item.value === formData.machinePrintingType)
      ?.brandNames || [];

  const selectedSubstrate =
    substrate.find((item) => item.value === formData.machinePrintingType)
      ?.type || [];

  // const handleFileChange = async (e) => {
  //   const file = e.target.files[0];
  //   setUploadLoading(true);

  //   if (file) {
  //     if (file.size > 2 * 1024 * 1024) {
  //       setErrors((prev) => ({
  //         ...prev,
  //         document: "File is too large (max size: 2MB) ",
  //       }));
  //       setUploadLoading(false);
  //       e.target.value = "";

  //       alert("File is too large (max size: 2MB)");
  //       return;
  //     }

  //     const formDataNew = new FormData();
  //     formDataNew.append("files", file);

  //     try {
  //       const token = localStorage.getItem("token");
  //       const response = await axios.post(
  //         `${process.env.REACT_APP_URL}/upload`,
  //         formDataNew,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );

  //       if (response.data.success) {
  //         errors.document = "";
  //         setUploadLoading(false);
  //         setPmFormData({
  //           ...formData,
  //           PrintingMachineImage: response?.data?.data[0],
  //         });
  //         // setdocumentUrl(response?.data?.data[0]);
  //       }
  //     } catch (err) {
  //       console.error("Error uploading file", err);
  //       setErrors((prev) => ({
  //         ...prev,
  //         document: "Error while uploading file ",
  //       }));

  //       setUploadLoading(false);
  //     }
  //   }
  // };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setUploadLoading(true);

    if (file) {
      try {
        const options = {
          maxSizeMB: 2,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        const compressedFile =
          file.size > 2 * 1024 * 1024
            ? await imageCompression(file, options)
            : file;

        const formDataNew = new FormData();
        formDataNew.append("files", compressedFile);

        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/upload`,
          formDataNew,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.data.success) {
          errors.document = "";
          setUploadLoading(false);
          setPmFormData({
            ...formData,
            PrintingMachineImage: response?.data?.data[0],
          });
        }
      } catch (err) {
        console.error("Error uploading file", err);
        setErrors((prev) => ({
          ...prev,
          document: "Error while uploading file ",
        }));
        setUploadLoading(false);
      }
    }
  };
  return (
    <Modal
      open={isOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={styles["modal-box"]}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                select
                fullWidth
                label="Printing Type"
                name="machinePrintingType"
                value={formData?.machinePrintingType || ""}
                onChange={handleChange}
                required
              >
                {printingOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <TextField
                select
                fullWidth
                label="Type of Printer"
                name="machinePrintingSubType"
                value={formData?.machinePrintingSubType || ""}
                onChange={handleChange}
                required
              >
                {printingSubOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                select
                fullWidth
                label="Print Width (feet)"
                name="maxPrintSize"
                value={formData?.maxPrintSize ? `${formData.maxPrintSize}` : ""}
                onChange={handleChange}
                required
              >
                {/* Check if a printing type is selected and get its widths */}
                {width[formData.machinePrintingType]?.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {formData.machinePrintingType !== "Plotter Cutting Printing" &&
              formData.machinePrintingType !== "UV Printing" &&
              formData.machinePrintingType !== "Latex Printing" && (
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    select
                    fullWidth
                    label="Picoliter"
                    name="picoliter"
                    value={formData?.picoliter ? `${formData.picoliter}` : ""}
                    onChange={(event) => {
                      setPmFormData({
                        ...formData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    required
                  >
                    {[
                      1.2,
                      1.5,
                      2.5,
                      3.5,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9,
                      10,
                      ...Array.from({ length: 25 }, (_, i) => i + 11),
                    ].map((num) => (
                      <MenuItem key={num} value={num}>
                        {num}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}

            <Grid item xs={12} sm={6} md={6}>
              {isOtherSelected ? (
                // Render a text field if "Other" is selected
                <TextField
                  fullWidth
                  label="Machine Brand"
                  name="machineBrand"
                  value={formData?.machineBrand || ""}
                  onChange={handleChange}
                  placeholder="Enter Machine Brand"
                  required
                />
              ) : (
                // Render the dropdown
                <TextField
                  select
                  fullWidth
                  label="Machine Brand"
                  name="machineBrand"
                  value={formData?.machineBrand || ""}
                  onChange={handleChange}
                  required
                >
                  {selectedBrandNames.map((brand, index) => (
                    <MenuItem key={index} value={brand}>
                      {brand}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                select // Enables dropdown
                fullWidth
                label="Age of Machine"
                name="ageOfMachine"
                value={formData?.ageOfMachine || ""}
                onChange={handleChange}
                required
              >
                <MenuItem value="0-4">0 to 4 years</MenuItem>
                <MenuItem value="4+">4 years and above</MenuItem>
              </TextField>

              {error && (
                <FormHelperText error>
                  Age of Machine is required
                </FormHelperText>
              )}
            </Grid>

            {uploadLoading ? (
              <Grid item xs={12} sm={6} md={6}>
                <FormHelperText>Waiting...</FormHelperText>
              </Grid>
            ) : formData.PrintingMachineImage ? (
              <Grid item xs={12} sm={6} md={6}>
                <Box
                  sx={{
                    position: "relative",
                    display: "inline-block",
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    p: 1,
                    ml: 2,
                  }}
                >
                  <img
                    src={formData.PrintingMachineImage}
                    alt="Fabrication Machine"
                    style={{
                      maxWidth: "100px",
                      maxHeight: "100px",
                      borderRadius: "4px",
                    }}
                  />
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      background: "white",
                      boxShadow: 1,
                    }}
                    onClick={() =>
                      setPmFormData((prev) => ({
                        ...prev,
                        PrintingMachineImage: "",
                      }))
                    }
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </Box>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <FormLabel className="text-[14px]">Upload Image:</FormLabel>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mt: 1,
                  }}
                >
                  <input
                    accept="image/*"
                    id="upload-image"
                    name="PrintingMachineImage"
                    type="file"
                    style={{ display: "none" }}
                    onChange={(e) => handleFileChange(e)}
                    className="w-full"
                  />
                  <label htmlFor="upload-image">
                    <IconButton
                      component="span"
                      sx={{
                        border: "1px dashed #ccc",
                        p: 1,
                        borderRadius: "8px",
                        bgcolor: "#f5f5f5",
                        ":hover": { bgcolor: "#e0e0e0" },
                      }}
                    >
                      <UploadFile />
                    </IconButton>
                  </label>
                </Box>
              </Grid>
            )}
            <Grid container spacing={2}>
              <Grid item xs={6} mt={2}></Grid>

              <Grid item xs={3} mt={2}>
                <GlobalButton
                  variant="secondary"
                  size="small"
                  onClick={handleClose}
                >
                  Close
                </GlobalButton>
              </Grid>
              <Grid item xs={3} mt={2}>
                <GlobalButton type="submit" variant="primary" size="small">
                  {isEditing ? "Update" : "Save"}
                </GlobalButton>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};

export default PrintMachineModal;
